import React,{useState} from 'react';
import {Card,Input,Button} from '../../components';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {handleAuthor_id} from '../../Utils';

const AddTask = ({tokenObject,connection,setSuccessfulMessage}) => {

    const [Title,setTitle] = useState("");
    const [Description,setDescription] = useState("");
    const [Email,setEmail] = useState("");
    const [Date,setDate] = useState("");
    const [wasSucceded,setWasSucceded] = useState(false);


    if(tokenObject.token === ""){
        return(
            <Redirect to="/login"/>
        );
    }

    (async function getEmail(){
        if(Email === ""){
            const result = await connection.get('/User',{
                headers:{
                    'user-access-token':tokenObject.token
                }
            });
            document.querySelector("#InputEmail").value = result.data.Email;
            setEmail(result.data.Email);
        }
    })();

    function handleEmail(event){
        setEmail(event.target.value);
    }

    function handleTitle(event){
        setTitle(event.target.value);
    }

    function handleDescription(event){
        setDescription(event.target.value);
    }

    function handleDate(event){
        setDate(event.target.value);
    }

    async function createTask(){

        const Author_id = await handleAuthor_id(Email,connection,tokenObject);

        const result = await connection.post('/Tasks',{
            Author_id:Author_id,
            Title:Title,
            Description:Description,
            Due_Date:Date
        },{
            headers:{
                'user-access-token':tokenObject.token
            }
        });

        setWasSucceded(setSuccessfulMessage(result.status));
    }

    return(
        <>
            <br/>
            {(function(){
                return wasSucceded ? (
                <div class="alert alert-success" role="alert">
                    Task successfully created!
                </div>) : (<></>)
                }
                )()}
            <Card>
                <br/>
                    <center><h1>Adicionar tarefa</h1></center>
                <br/>
                <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">E-mail</label>
                        <Input type="email" id="InputEmail" onKeyUp={handleEmail}/>
                        <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Nome da Tarefa</label>
                        <Input type="text" onKeyUp={handleTitle}/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Descrição da Tarefa</label>
                        <Input type="text" onKeyUp={handleDescription}/>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="exampleInputEmail1" className="form-label">Data de entrega / Data do evento</label>
                        <Input type="Date" onChange={handleDate}/>
                    </div>
                <br/>
                    <Button type="primary" onClick={createTask}>Adicionar Tarefa</Button>
            </Card>
        </>
    );
}

const mapStateToProps = (state) => ({
    tokenObject:state.token
})

export default connect(mapStateToProps)(AddTask);